"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _checkbox = _interopRequireDefault(require("britive-design-system/core/components/checkbox"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _DataTable = _interopRequireDefault(require("../../../../data-table/DataTable"));

var _bs = require("react-icons/bs");

var _AddTags = _interopRequireDefault(require("./tags/AddTags"));

var _AddIdentities = _interopRequireDefault(require("./identities/AddIdentities"));

var _AddIdentities2 = _interopRequireDefault(require("./add-users/AddIdentities"));

var _AddAPITokens = _interopRequireDefault(require("./api-tokens/AddAPITokens"));

var _commonConstants = require("../../../../../utils/common-constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commonUtils = require("../../../../../utils/common-utils");

var _lodash = require("lodash");

var _constants = require("./constants");

var _fa = require("react-icons/fa");

var _TagMembers = _interopRequireDefault(require("./tags/TagMembers"));

var _constants2 = require("../../../../../common-widgets/approval-modal/constants");

var _actions = require("../../../../policy/Members/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.policy-members-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .policy-members-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .policy-members-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .policy-members-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .policy-members-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .policy-members-tab-main-container .sm-form-name-loader-wrapper {\n    display: flex;\n    align-items: center; }\n    .policy-members-tab-main-container .sm-form-name-loader-wrapper .sm-form-name-check-loader {\n      margin-top: 1.25rem;\n      margin-left: 0.625rem; }\n  .policy-members-tab-main-container .sm-add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .policy-members-tab-main-container .sm-add-policy-field-value-wrapper {\n    margin-top: 0.5rem; }\n  .policy-members-tab-main-container .sm-value-wrapper {\n    margin-top: 0.625rem; }\n  .policy-members-tab-main-container .sm-add-policy-title-wrapper {\n    padding-bottom: 1.25rem;\n    margin-bottom: 2rem;\n    border-bottom: 1px solid #c6c6c6; }\n  .policy-members-tab-main-container .sm-add-policy-members-section-wrapper {\n    padding: 1.5rem 0; }\n  .policy-members-tab-main-container .add-members-button-wrapper {\n    margin: 0.5rem 0; }\n  .policy-members-tab-main-container .sm-add-policy-table-wrapper {\n    margin-top: 0.5rem;\n    max-height: 20rem;\n    overflow-y: scroll; }\n";
  var fileName = "compone_AddMembers";
  var element = document.querySelector("style[data-sass-component='compone_AddMembers']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Members = function Members(_ref) {
  var validationHook = _ref.validationHook,
      usersData = _ref.usersData,
      usersDataStatus = _ref.usersDataStatus,
      groupsData = _ref.groupsData,
      groupsDataStatus = _ref.groupsDataStatus,
      serviceIdentitiesData = _ref.serviceIdentitiesData,
      serviceIdentitiesDataStatus = _ref.serviceIdentitiesDataStatus,
      tokensData = _ref.tokensData,
      tokensDataStatus = _ref.tokensDataStatus,
      initSpinnerOverlay = _ref.initSpinnerOverlay,
      translatedStrings = _ref.translatedStrings,
      consumer = _ref.consumer,
      papPolicy = _ref.papPolicy;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      resourcesLoading = _useState2[0],
      setResourcesLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      addUsersModalVisibility = _useState4[0],
      setAddUsersModalVisibility = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      addSIModalVisibility = _useState6[0],
      setAddSIModalVisibility = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      addTagModalVisibility = _useState8[0],
      setAddTagModalVisibility = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      membersTagId = _useState10[0],
      setMembersTagId = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      membersModalTitle = _useState12[0],
      setMembersModalTitle = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      addTokensModalVisibility = _useState14[0],
      setAddTokensModalVisibility = _useState14[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    setResourcesLoading((0, _commonUtils.isLoading)(groupsDataStatus) || (0, _commonUtils.isLoading)(usersDataStatus) || (0, _commonUtils.isLoading)(serviceIdentitiesDataStatus) || (0, _commonUtils.isLoading)(tokensDataStatus));
  }, [groupsDataStatus, usersDataStatus, serviceIdentitiesDataStatus, tokensDataStatus]);
  (0, _react.useEffect)(function () {
    initSpinnerOverlay({
      open: resourcesLoading,
      size: _commonConstants.medium,
      message: translatedStrings.loadingMembers
    });
  }, [resourcesLoading]);
  var allFields = [{
    name: _commonConstants.userField,
    label: translatedStrings.userLabel
  }, {
    name: _commonConstants.groupField,
    label: translatedStrings.groupLabel
  }, {
    name: _commonConstants.siField,
    label: translatedStrings.serviceIdentityLabel
  }];

  var closeMembersModal = function closeMembersModal() {
    setMembersTagId(null);
    setMembersModalTitle(null);
    dispatch((0, _actions.resetTagMembersRequest)());
  };

  var handleAddMembers = function handleAddMembers() {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (label.toLowerCase() === translatedStrings.tags.toLowerCase()) {
      setAddTagModalVisibility(true);
    } else if (label.toLowerCase() === translatedStrings.users.toLowerCase()) {
      setAddUsersModalVisibility(true);
    } else if (label.toLowerCase() === translatedStrings.si.toLowerCase()) {
      setAddSIModalVisibility(true);
    } else {
      setAddTokensModalVisibility(true);
    }
  };

  var getFields = function getFields() {
    if (consumer !== _commonConstants.papServiceConsumer) {
      allFields.push({
        name: _commonConstants.tokenField,
        label: translatedStrings.tokenLabel
      });
    }

    return allFields;
  };

  var getPropertyName = function getPropertyName(name) {
    return "all".concat((0, _commonUtils.capitalizeFirstLetter)(name));
  };

  var getUniqueIdentifier = function getUniqueIdentifier(name) {
    switch (name) {
      case _commonConstants.userField:
        return "userId";

      case _commonConstants.groupField:
        return "userTagId";

      case _commonConstants.siField:
        return "userId";

      case _commonConstants.tokenField:
        return "id";
    }
  };

  var _updateSelection = function updateSelection(name, data) {
    validationHook.handleChange(validationHook.names[name], data);
  };

  var getField = function getField(name, label) {
    var fieldName = getPropertyName(name);
    var membersProps = {
      name: name,
      label: "All ".concat(label),
      checked: validationHook.values[fieldName],
      onChange: function onChange(e) {
        return validationHook.handleChange(validationHook.names[fieldName], e.target.checked);
      }
    };

    var handleDeleteClick = function handleDeleteClick(row) {
      var currentTableData = _toConsumableArray(validationHook.values[name]);

      var uniqueIdentifier = getUniqueIdentifier(name);
      var filteredData = currentTableData.filter(function (entity) {
        return entity[uniqueIdentifier] !== row[uniqueIdentifier];
      });

      _updateSelection(name, filteredData);
    };

    var actionColumn = {
      headerName: translatedStrings.actionColumn,
      width: '80px',
      renderColumn: function renderColumn(row) {
        return /*#__PURE__*/_react.default.createElement(_bs.BsTrash, {
          onClick: function onClick() {
            return handleDeleteClick(row);
          },
          size: 24
        });
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "field-".concat(name),
      className: _constants.classes.addPolicyMembersSectionWrapper
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.addPolicyMembersTitleWrapper
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label2"
    }, label)), !papPolicy && /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.addPolicyFieldWrapper
    }, /*#__PURE__*/_react.default.createElement(_checkbox.default, membersProps)), !membersProps.checked && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.addMembersButtonWrapper
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: function onClick() {
        return handleAddMembers(label);
      }
    }, "Select ", label)), /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.addPolicyTableWrapper
    }, /*#__PURE__*/_react.default.createElement(_DataTable.default, {
      rows: validationHook.values[name],
      columns: [].concat(_toConsumableArray(getFieldColumns(name)), [actionColumn])
    }))));
  };

  var isMembersListEmpty = function isMembersListEmpty(name) {
    switch (name) {
      // case userField:
      //   return isEmpty(usersData);
      // case groupField:
      //   return isEmpty(groupsData);
      case _commonConstants.siField:
        return (0, _lodash.isEmpty)(serviceIdentitiesData);

      case _commonConstants.tokenField:
        return (0, _lodash.isEmpty)(tokensData);
    }
  };

  var getFieldLabel = function getFieldLabel(name) {
    switch (name) {
      case _commonConstants.userField:
        return translatedStrings.users;

      case _commonConstants.groupField:
        return translatedStrings.tags;

      case _commonConstants.siField:
        return translatedStrings.si;

      case _commonConstants.tokenField:
        return translatedStrings.tokens;
    }
  };

  var getFieldColumns = function getFieldColumns(name) {
    switch (name) {
      case _commonConstants.userField:
      default:
        return [{
          field: 'firstName',
          headerName: 'First Name',
          sortable: true
        }, {
          field: 'lastName',
          headerName: 'Last Name',
          sortable: true
        }, {
          field: 'username',
          headerName: 'Username',
          sortable: true
        }, {
          field: 'email',
          headerName: 'Email',
          sortable: true
        }];

      case _commonConstants.groupField:
        return [{
          field: 'name',
          headerName: 'Name',
          sortable: true
        }, {
          field: 'description',
          headerName: 'Description',
          sortable: true
        }, {
          headerName: 'Members',
          sortable: true,
          renderColumn: function renderColumn(row) {
            return /*#__PURE__*/_react.default.createElement("div", {
              style: {
                display: 'flex'
              }
            }, row.userCount, "\xA0", /*#__PURE__*/_react.default.createElement(_button.default, {
              variant: "textOnly",
              size: "small",
              onClick: function onClick() {
                setMembersTagId(row.userTagId);
                setMembersModalTitle(row.name);
              }
            }, row.userCount > 0 ? /*#__PURE__*/_react.default.createElement(_fa.FaSearch, {
              color: _commonUtils.blue60
            }) : null));
          }
        }];

      case _commonConstants.siField:
        return [{
          field: 'name',
          headerName: 'Name',
          sortable: true
        }, {
          field: 'description',
          headerName: 'Description',
          sortable: true
        }];

      case _commonConstants.tokenField:
        return [{
          field: 'name',
          headerName: 'Name',
          sortable: true
        }, {
          field: 'createdBy',
          headerName: 'Created By',
          sortable: true
        }];
    }
  };

  var getFieldEmptyResultText = function getFieldEmptyResultText(name) {
    switch (name) {
      // case userField: {
      //   return translatedStrings.noUsersFound;
      // }
      // case groupField: {
      //   return translatedStrings.noTagsFound;
      // }
      case _commonConstants.siField:
        {
          return translatedStrings.noSIFound;
        }

      case _commonConstants.tokenField:
        {
          return translatedStrings.noTokensFound;
        }
    }
  };

  var getNoDataField = function getNoDataField(name) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "no-data-".concat(name),
      className: _constants.classes.addPolicyFieldWrapper
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "heading7"
    }, getFieldLabel(name)), /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.valueWrapper
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label1"
    }, getFieldEmptyResultText(name))));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.stepperMainContainer
  }, getFields().map(function (item) {
    var name = item.name,
        label = item.label;
    return isMembersListEmpty(name) ? getNoDataField(name) : getField(name, label);
  })), /*#__PURE__*/_react.default.createElement(_AddIdentities2.default, {
    data: usersData,
    showModal: addUsersModalVisibility,
    onModalClose: setAddUsersModalVisibility,
    translatedStrings: translatedStrings,
    identityType: translatedStrings.userLabel,
    updateSelection: function updateSelection(data) {
      _updateSelection(_commonConstants.userField, data);
    },
    selectedData: validationHook.values.user
  }), /*#__PURE__*/_react.default.createElement(_AddIdentities.default, {
    data: serviceIdentitiesData,
    showModal: addSIModalVisibility,
    onModalClose: setAddSIModalVisibility,
    translatedStrings: translatedStrings,
    identityType: translatedStrings.serviceIdentityLabel,
    updateSelection: function updateSelection(data) {
      _updateSelection(_commonConstants.siField, data);
    },
    selectedData: validationHook.values.serviceIdentity
  }), /*#__PURE__*/_react.default.createElement(_AddTags.default, {
    tagData: groupsData,
    showModal: addTagModalVisibility,
    onModalClose: setAddTagModalVisibility,
    translatedStrings: translatedStrings,
    updateSelection: function updateSelection(data) {
      _updateSelection(_commonConstants.groupField, data);
    },
    selectedData: validationHook.values.group
  }), /*#__PURE__*/_react.default.createElement(_AddAPITokens.default, {
    data: tokensData,
    showModal: addTokensModalVisibility,
    onModalClose: setAddTokensModalVisibility,
    translatedStrings: translatedStrings,
    updateSelection: function updateSelection(data) {
      _updateSelection(_commonConstants.tokenField, data);
    },
    selectedData: validationHook.values.token
  }), membersTagId ? /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: '50%',
    title: membersModalTitle,
    onCancel: closeMembersModal,
    buttons: [{
      text: translatedStrings.cancelBtn,
      variant: _constants2.adminSecretListConstants.secVariant,
      onClick: closeMembersModal,
      size: _constants2.adminSecretListConstants.largeSize
    }]
  }, /*#__PURE__*/_react.default.createElement(_TagMembers.default, {
    tagId: membersTagId
  })) : null);
};

Members.propTypes = {
  validationHook: _propTypes.default.object,
  usersData: _propTypes.default.array,
  usersDataStatus: _propTypes.default.string,
  groupsData: _propTypes.default.array,
  groupsDataStatus: _propTypes.default.string,
  serviceIdentitiesData: _propTypes.default.array,
  serviceIdentitiesDataStatus: _propTypes.default.string,
  tokensData: _propTypes.default.array,
  tokensDataStatus: _propTypes.default.string,
  initSpinnerOverlay: _propTypes.default.func,
  translatedStrings: _propTypes.default.object,
  consumer: _propTypes.default.string,
  papPolicy: _propTypes.default.bool
};
var _default = Members;
exports.default = _default;